import { Admin, ClientFieldRule, ClientInputPermission } from "@resamare/models";
import { useQuery } from "@tanstack/react-query";
import { boolean, number, object, ValidationError } from "yup";
import { apiClient } from "../../../config";

export const adminResponseSchema = object().shape({
    admin_id: number().required().positive().integer(),
    admin_gratuite_desactiver: boolean().required(),
    admin_caisse_nom: number<ClientFieldRule>()
        .required()
        .oneOf(Object.values(ClientFieldRule) as number[]),
    admin_caisse_prenom: number<ClientFieldRule>()
        .required()
        .oneOf(Object.values(ClientFieldRule) as number[]),
    admin_caisse_mail: number<ClientFieldRule>()
        .required()
        .oneOf(Object.values(ClientFieldRule) as number[]),
    admin_caisse_tel: number<ClientFieldRule>()
        .required()
        .oneOf(Object.values(ClientFieldRule) as number[]),
    admin_caisse_client: boolean().required(),
    admin_caisse_client_guichet: number<ClientInputPermission>()
        .required()
        .oneOf(Object.values(ClientInputPermission) as number[]),
    admin_caisse_specifique: boolean().required(),
    admin_type_id: number().required().integer().min(0),
    canal_vente: object()
        .shape({
            id: number().required().positive().integer(),
            delais_vente: number().required().integer(),
        })
        .default(undefined),
});

export async function getAdmin(): Promise<Admin | null> {
    try {
        const response = await apiClient.get("/api/admin");
        const admin = await adminResponseSchema.validate(response.data, { stripUnknown: true });
        return admin;
    } catch (err) {
        if (err instanceof ValidationError) {
            throw err;
        }
        return null;
    }
}

export function useGetAdmin() {
    const query = useQuery({
        queryKey: ["admin"],
        queryFn: getAdmin,
    });

    return query;
}
